import {
  APPLE_PAY_EMAIL,
  CASH_APP_URL,
  CompanyName,
  CompanyPhoneNumber,
  FULL_BUSINESS_URL,
  LocationCountry,
  THRONE_URL,
  VENMO_URL,
} from '../Constants';

export const newsletterValidationStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Newsletter Email Confirmation',
  url: `${FULL_BUSINESS_URL}/newsletter/confirm-email`, // Adjust accordingly
  description: `Confirmation page for newsletter subscription to ${CompanyName}.`,
  mainEntity: {
    '@type': 'Organization',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    // sameAs: [
    //   FACEBOOK_URL,
    //   INSTAGRAM_URL,
    //   LINKEDIN_URL,
    // ],
  },
};

export const newsletterValidationAdditionalMeta = [
  {
    property: 'og:title',
    content: `Confirm your subscription – ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Thanks for subscribing to the ${CompanyName} newsletter. This confirms your email address.`,
  },
  {
    property: 'og:url',
    content: `${FULL_BUSINESS_URL}/newsletter/confirm-email`,
  },
  { name: 'robots', content: 'noindex, follow' }, // Optional, prevents indexing
];

export const newsletterUnsubscribeStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${CompanyName} Newsletter Unsubscribe`,
  url: `${FULL_BUSINESS_URL}/newsletter/unsubscribe`,
  description: `Unsubscribe from the ${CompanyName} newsletter and stop receiving further updates or promotions.`,
  mainEntity: {
    '@type': 'Organization',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    // sameAs could be added here if you want social links
  },
};

export const newsletterUnsubscribeAdditionalMeta = [
  {
    property: 'og:title',
    content: `Unsubscribe from ${CompanyName} Newsletter`,
  },
  {
    property: 'og:description',
    content: `You've chosen to unsubscribe from the ${CompanyName} newsletter. We're sorry to see you go, but you're always welcome back.`,
  },
  {
    property: 'og:url',
    content: `${FULL_BUSINESS_URL}/newsletter/unsubscribe`,
  },
  { name: 'robots', content: 'noindex, follow' }, // Prevent indexing if desired
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Unsubscribe – ${CompanyName} Newsletter`,
  },
  {
    name: 'twitter:description',
    content: `Manage your email preferences and stop receiving the ${CompanyName} newsletter.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/logo.png`,
  },
];

export const bookingPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: `${CompanyName} Booking`,
  serviceType: 'Web and Circuit Design Services Booking',
  provider: {
    '@type': 'Organization',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    telephone: CompanyPhoneNumber,
  },
  areaServed: {
    '@type': 'Country',
    name: 'United Kingdom',
  },
  availableChannel: {
    '@type': 'ServiceChannel',
    serviceUrl: `${FULL_BUSINESS_URL}/booking`,
    availableLanguage: 'English',
  },
  description: `Easily schedule a consultation or service with ${CompanyName} for expert web and circuit design solutions.`,
};

export const bookingPageAdditionalMeta = [
  { property: 'og:title', content: `Book with ${CompanyName}` },
  {
    property: 'og:description',
    content:
      'Schedule your web or circuit design service today with our easy online booking.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/booking` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Book with ${CompanyName}` },
  {
    name: 'twitter:description',
    content: 'Secure your session with our expert team in just a few clicks.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
];

// Home page
export const homePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: CompanyName,
  url: FULL_BUSINESS_URL,
  description: `${CompanyName} is Norway’s premier dominatrix, offering exclusive BDSM experiences, online sessions, and fetish content.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: `${CompanyPhoneNumber}`,
    contactType: 'Bookings & Inquiries',
    areaServed: 'Norway',
    availableLanguage: ['English', 'Norwegian'],
  },
};

export const newsletterPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Miss Dominatrixa Newsletter Sign-Up',
  url: `${FULL_BUSINESS_URL}/newsletter`,
  description: `Subscribe to Miss Dominatrixa’s exclusive newsletter for sensual insights, updates, and VIP-only invitations to elite experiences in Norway and beyond.`,
  publisher: {
    '@type': 'Person',
    name: 'Miss Dominatrixa',
    url: FULL_BUSINESS_URL,
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Booking & Inquiries',
    areaServed: 'NO',
    availableLanguage: ['English', 'Norwegian'],
  },
};

export const newsletterPageAdditionalMeta = [
  { property: 'og:title', content: 'Join Miss Dominatrixa’s Inner Circle' },
  {
    property: 'og:description',
    content:
      'Get exclusive access to updates, private announcements, and VIP invites from Miss Dominatrixa in Norway.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/newsletter` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Join Miss Dominatrixa’s Newsletter' },
  {
    name: 'twitter:description',
    content:
      'Subscribe now to receive personal insights and elite offerings from Norway’s premier dominatrix.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
];

export const homePageAdditionalMeta = [
  { property: 'og:title', content: `Enter the World of ${CompanyName}` },
  {
    property: 'og:description',
    content:
      'Indulge in elite domination, bespoke sessions, and exclusive content with Norway’s top dominatrix.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
  { property: 'og:url', content: FULL_BUSINESS_URL },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Step into ${CompanyName}'s Domain` },
  {
    name: 'twitter:description',
    content:
      'Elite BDSM experiences and personalized domination services await you.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
];

// About page
export const aboutPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Miss Dominatrixa',
  url: FULL_BUSINESS_URL,
  jobTitle: 'Elite Dominatrix & Femdom Specialist',
  description:
    'Miss Dominatrixa is a supreme force of control, seduction, and discipline, offering exclusive experiences for those who crave true submission.',
  image: {
    '@type': 'ImageObject',
    url: `${FULL_BUSINESS_URL}/brand/miss-dominatrixa-profile.jpg`,
  },
  knowsAbout: [
    'Female Domination',
    'BDSM Mastery',
    'Fetish Exploration',
    'Power Exchange & Control',
    'Discipline & Training',
  ],
};

export const aboutPageAdditionalMeta = [
  {
    property: 'og:title',
    content: 'Miss Dominatrixa – Supreme Domination & Obedience',
  },
  {
    property: 'og:description',
    content:
      'Enter the world of Miss Dominatrixa, where control is absolute, submission is earned, and obedience is rewarded. Experience the depths of true devotion.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/miss-dominatrixa-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/bio` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: 'Miss Dominatrixa – Supreme Domination & Obedience',
  },
  {
    name: 'twitter:description',
    content:
      'Surrender to the authority of Miss Dominatrixa. Indulge in a world where your submission is My pleasure.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/miss-dominatrixa-preview.jpg`,
  },
];

// Online Sessions Page
export const onlinePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `Online Sessions - ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/online-sessions`,
  description: `Book an exclusive online BDSM session with ${CompanyName}. Experience domination, humiliation, and control from anywhere in the world through video or text-based interactions.`,
  publisher: {
    '@type': 'Organization',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
  potentialAction: {
    '@type': 'ViewAction',
    target: `${FULL_BUSINESS_URL}/online-sessions`,
  },
};

export const onlinePageAdditionalMeta = [
  {
    property: 'og:title',
    content: `Online Sessions - ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Experience the power of ${CompanyName} from anywhere with her exclusive online BDSM sessions. Domination, control, and obedience at your fingertips.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/online-sessions.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/online-sessions` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Online Sessions - ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content: `Book an online BDSM session with ${CompanyName}. Engage in real-time domination, obedience training, and fetish exploration from anywhere in the world.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/online-sessions.jpg`,
  },
];

// Real-Time Sessions Page
export const realTimePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `Real-Time Sessions - ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/real-time-sessions`,
  description: `Book an exclusive real-time BDSM session with ${CompanyName} in ${LocationCountry}. Experience dominance, submission, and power exchange in a fully equipped dungeon.`,
  publisher: {
    '@type': 'Organization',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
  potentialAction: {
    '@type': 'ViewAction',
    target: `${FULL_BUSINESS_URL}/real-time-sessions`,
  },
};

export const realTimePageAdditionalMeta = [
  {
    property: 'og:title',
    content: `Real-Time Sessions - ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Step into ${CompanyName}’s dungeon in ${LocationCountry} for an unforgettable real-time BDSM session. Surrender to her control and experience true submission.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/real-time-sessions.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/real-time-sessions` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Real-Time Sessions - ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content: `Indulge in a real-time BDSM session with ${CompanyName} in ${LocationCountry}. Experience ultimate domination in a fully equipped dungeon.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/real-time-sessions.jpg`,
  },
];

export const ratesTributesPageAdditionalMeta = [
  {
    name: 'description',
    content: `Explore ${CompanyName}’s session rates and tributes. Secure your unforgettable experience with a professional Dominatrix today.`,
  },
  {
    name: 'keywords',
    content: `${CompanyName} rates, Dominatrix tributes, BDSM session fees, professional Domme prices, booking tribute`,
  },
  {
    property: 'og:title',
    content: `Rates & Tributes – ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Discover the session rates and tributes required to experience the unrivaled dominance of ${CompanyName}. Tribute accordingly, and surrender completely.`,
  },
  { property: 'og:type', content: 'website' },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/rates-tributes` },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/tribute-banner.jpg`,
  },
];
export const galleryPageAdditionalMeta = [
  {
    name: 'description',
    content: `Browse the exclusive gallery of ${CompanyName}. Explore captivating images from our sessions, showcasing the art of domination and submission in ${LocationCountry}.`,
  },
  {
    name: 'keywords',
    content: `${CompanyName} gallery, BDSM photography, domination images, submissive experiences, fetish photography, ${LocationCountry}, exclusive content`,
  },
  {
    property: 'og:title',
    content: `Gallery – ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Step into the visual world of ${CompanyName}. View exclusive images capturing the intensity and beauty of domination and submission.`,
  },
  { property: 'og:type', content: 'website' },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/gallery` },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/gallery-banner.jpg`,
  },
];

export const galleryPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Gallery',
  description: `Discover the world of ${CompanyName} through our exclusive gallery. View captivating images from our sessions and experiences.`,
  url: `${FULL_BUSINESS_URL}/gallery`,
  image: `${FULL_BUSINESS_URL}/assets/images/gallery-banner.jpg`,
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: `${FULL_BUSINESS_URL}/`,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Gallery',
        item: `${FULL_BUSINESS_URL}/gallery`,
      },
    ],
  },
};

export const dungeonPageAdditionalMeta = [
  {
    name: 'description',
    content: `Step into ${CompanyName}’s Dungeon, where submission meets seduction. Explore exclusive domination content, tributes, and indulgent offerings.`,
  },
  {
    name: 'keywords',
    content: `${CompanyName} dungeon, online domination, BDSM content, financial domination, keyholding, used items, fetish services`,
  },
  {
    property: 'og:title',
    content: `The Dungeon – ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Enter ${CompanyName}’s domain of control. Browse exclusive content, pay tributes, and surrender to the power of true domination.`,
  },
  { property: 'og:type', content: 'website' },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/dungeon` },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/dungeon-banner.jpg`,
  },
];

export const dungeonPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'The Dungeon',
  description: `Explore ${CompanyName}’s Dungeon for exclusive content, tributes, and opportunities to serve.`,
  url: `${FULL_BUSINESS_URL}/dungeon`,
  image: `${FULL_BUSINESS_URL}/assets/images/dungeon-banner.jpg`,
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: `${FULL_BUSINESS_URL}/`,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'The Dungeon',
        item: `${FULL_BUSINESS_URL}/dungeon`,
      },
    ],
  },
};

export const ratesTributesPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Rates & Tributes',
  description: `View ${CompanyName}’s session rates and tributes for a professional, unforgettable BDSM experience.`,
  url: `${FULL_BUSINESS_URL}/rates-tributes`,
  image: `${FULL_BUSINESS_URL}/assets/images/tribute-banner.jpg`,
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: `${FULL_BUSINESS_URL}/`,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Rates & Tributes',
        item: `${FULL_BUSINESS_URL}/rates-tributes`,
      },
    ],
  },
};

// Maintenance
export const maintenancePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Maintenance Page',
  description: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back soon!`,
  url: `${FULL_BUSINESS_URL}/maintenance`,
};

export const maintenancePageAdditionalMeta = [
  { property: 'og:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    property: 'og:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/maintenance` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
];

// Policies page
export const termsAndPoliciesStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Terms and Policies',
  description: `Explore the terms of service and privacy policies of ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/terms-and-policies`,
  mainEntity: {
    '@type': 'FAQPage',
    name: 'Terms and Policies FAQ',
    description: `Frequently asked questions about terms of service, privacy policies, and compliance at ${CompanyName}.`,
  },
};

export const termsAndPoliciesAdditionalMeta = [
  { property: 'og:title', content: `Terms and Policies - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Understand the terms of service, privacy policies, and compliance guidelines of ${CompanyName}.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/terms-and-policies` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Terms and Policies - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Learn more about our terms of service, privacy policies, and compliance at ${CompanyName}.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
];

// Error page
export const errorPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '404 Error Page',
  description: `The requested page could not be found on ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/404`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const errorPageAdditionalMeta = [
  { property: 'og:title', content: 'Page Not Found - 404' },
  {
    property: 'og:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/404` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Page Not Found - 404' },
  {
    name: 'twitter:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
];

export const faqPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  name: `${CompanyName} - Frequently Asked Questions`,
  url: FULL_BUSINESS_URL + '/faq',
  description: `Find answers to common questions about sessions, expectations, and how to engage with ${CompanyName} in Norway and the EU.`,
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What services do you offer?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: `I provide a range of elite BDSM experiences in Norway and across the EU, including domination, sensory play, and bespoke sessions tailored to mutual interests. Full details can be found on my Sessions page.`,
      },
    },
    {
      '@type': 'Question',
      name: 'How do I book a session?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: `To book a session, visit my Contact page and follow the instructions for scheduling. A deposit may be required to confirm your appointment.`,
      },
    },
    {
      '@type': 'Question',
      name: 'What are your session rules and expectations?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: `Respect, communication, and consent are paramount. All clients must adhere to my guidelines, which are clearly outlined on my website. Failure to do so may result in a terminated session.`,
      },
    },
  ],
};

export const faqPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} - FAQ` },
  {
    property: 'og:description',
    content: `Find answers to common questions about sessions, expectations, and how to engage with ${CompanyName} in Norway and the EU.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/images/faq-cover.jpg`,
  },
  { property: 'og:url', content: FULL_BUSINESS_URL + '/faq' },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} - FAQ` },
  {
    name: 'twitter:description',
    content: `Your questions answered about ${CompanyName} and her sessions in Norway and the EU.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/images/faq-cover.jpg`,
  },
];

// Contact page
export const contactPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  mainEntity: {
    '@type': 'Organization',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: CompanyPhoneNumber,
      contactType: 'Bookings & Inquiries',
      areaServed: 'Norway',
      availableLanguage: ['English', 'Norwegian'],
    },
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
};

export const contactPageAdditionalMeta = [
  { property: 'og:title', content: `Contact ${CompanyName}` },
  {
    property: 'og:description',
    content: `Submit your booking request or inquiry to ${CompanyName}. Exclusive sessions and personalized domination experiences await.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/contact-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/contact` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Contact ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Get in touch with ${CompanyName} to arrange your next elite domination experience. Discretion and professionalism guaranteed.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/contact-preview.jpg`,
  },
];

// Links & Pay Sites Page
export const linksPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `Exclusive Links & Tribute Options - ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/links`,
  description: `Discover all official ways to connect with ${CompanyName}, including premium content, tribute options, and private platforms.`,
  sameAs: [
    `${THRONE_URL}`,
    `${CASH_APP_URL}`,
    `${VENMO_URL}`,
    `${APPLE_PAY_EMAIL}`,
  ],
};

export const linksPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `Exclusive Links & Tribute Options - ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Explore all official platforms where you can connect, indulge, and tribute to ${CompanyName}.`,
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/links` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Exclusive Links & Tribute Options - ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content: `Access premium content, tribute options, and exclusive ways to engage with ${CompanyName}.`,
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
];
